import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Effect, ofType, Actions } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import * as recaptchaActions from './../actions/recaptcha.actions'
import * as loggerActions from './../actions/logger.actions'
import { mergeMap, map, catchError, tap } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { RecaptchaService } from '../../services/recaptcha.service';

@Injectable()
export class RecaptchaEffects {
  constructor(private recaptchaService: RecaptchaService, private actions$: Actions) {
  }

  @Effect()
  validateReCaptcha$: Observable<Action> = this.actions$.pipe(
    ofType(recaptchaActions.ValidateReCaptcha),
    mergeMap((action) =>
      this.recaptchaService.valdateReCaptcha(action.reCaptcha).pipe(
        mergeMap((success: boolean) =>
          [(recaptchaActions.ValidatedReCaptcha({ success: success }))]),
        catchError((err: HttpErrorResponse) => { 
          return [
            recaptchaActions.ValidateReCaptchaError({ errorMessage: err.message }),
            loggerActions.Exception({ error: err })
          ]
        }
        )
			)
		)
	);

}
